<template>
    <div class="agreement" :class="{'agreementDark': isDark}">
        <h3>"即嗨"用户协议</h3>
        <h4>一、总则</h4>
        本协议是用户与{{isIos ? '贵州即嗨网络科技有限公司' : '西藏嗨娱网络科技有限公司'}}（以下简称“{{companyName}}”）之间关于用户使用“即嗨”的法律协议。“用户”是指愿意接受或“即嗨”提供的游戏产品和服务的个人。“即嗨”是“{{companyName}}”推出的体育数据产品。为进一步明确，本协议项下“即嗨”亦用于指代“{{companyName}}”。
    <h5>1.1</h5>
    用户按照页面上的提示完成全部的注册程序，注册成功即表示用户与“{{companyName}}”达成协议，并且完全接受本协议项下的全部条款。用户如不同意本服务条款任意内容，请勿注册或使用“即嗨”。
    <h5>1.2</h5>
    注册成功后，“即嗨”将给予每个用户一个“用户账户”（以下简称“账号”），该账号由用户负责保管；用户应当对使用该账号在“即嗨”所有行为和事件负法律责任。
    <h5>1.3</h5>
    此协议可由“即嗨”根据国家法律政策或公司运营要求随时更新，且无需另行通知。用户在使用相关服务时应关注本协议及其他服务规则的变化。若用户不同意本协议或相关服务规则或不同意“即嗨”做出的修改，用户可主动停止使用“即嗨”提供的产品和服务，若在“即嗨”修改协议或服务规则后用户仍继续使用“即嗨”提供的产品和服务，即表示用户同意“即嗨”对本协议及相关服务规则所做的所有修改。由于用户在协议变更后因未熟悉该变更而引起的损失，“即嗨”不承担任何责任。用户在使用“即嗨”提供的各项服务之前，应仔细阅读本协议。此后，用户不得以未阅读本服务协议作任何形式的抗辩。
    <h4>二、用户的注册信息</h4>
    <h5>2.1 </h5>
    用户注册信息应合法、真实、有效。用户在注册“即嗨”账号时，应按照注册提示真实、完整地填写相关信息并及时更新，保证该等注册信息自账号注册起至账号注销止的期间内始终处于真实、有效状态，且不得侵犯其他第三方的合法权益。因用户填写的注册信息存在错误、虚假、违法等情形导致的任何法律后果及经济损失，均由该用户自行承担。
    <h5>2.2 </h5>
    如果用户注册信息不合法、不真实、不准确、不完整，或者“{{companyName}}”有合理理由怀疑其注册信息为不合法、不真实、不准确、不完整，“{{companyName}}”有权暂停或终止该用户账号的使用，并拒绝用户继续使用“{{companyName}}”的部分或全部功能。
    <h5>2.3 </h5>
    如果因用户注册信息不合法、不真实、不准确、不完整，或用户未及时更新注册信息，导致“{{companyName}}”无法提供服务或提供服务时发生任何错误，“{{companyName}}”不承担任何责任，所有后果应由该用户承担。
    <h4>三、使用规则</h4>
    <h5>3.1</h5>
    用户在使用“即嗨”产品服务的过程中，应当遵循以下规则：
    <br/>1) 遵守中华人民共和国有关的法律和法规。
    <br/>2) 不得为任何非法目的及与“即嗨”提供服务或产品未有直接关系而使用网络服务系统：包括但不限于买卖账号、虚拟货币等。
    <br/>3) 不得对包括但不限于“即嗨”的网站及提供的软件进行修改。
    <br/>4) 不得采用任何可能影响“即嗨”的网络服务的非正常使用行为（包括但不限于损害、攻击服务器或使服务器过度负荷等）。
    <br/>5) 不得通过第三方软件或在第三方软件的辅助下使用“即嗨”的产品或接受“即嗨”的服务。
    <br/>6) 未经“即嗨”的书面许可，不得使用“即嗨”任何知识产品，来创造或提供相同或类似的网络服务，如仿真服务器、私人服务器等。
    <br/>7) 不得利用“即嗨”网络服务系统进行任何可能对互联网的正常运转造成不利影响或可能干扰他人以正常方式使用“即嗨”所提供的产品和网络服务的行为。
    <br/>8) 不得利用“即嗨”网络服务系统传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的、欺诈性的或其他任何非法的信息资料。
    <br/>9) 任何利用“即嗨”服务系统进行其他不利于“即嗨”的行为，一经“即嗨”甄别认定，“即嗨”将有权暂时或永久封禁违规账号而不需事先经过用户同意，违规行为包括但不限于：
    <br/>a) 频繁注册“即嗨”账号恶意占用“即嗨”账号资源进行非法获利行为。
    <br/>b) 用户与用户之间禁止在线下相互叫卖、转让“即嗨”所提供的服务（包括但不限于嗨币）。
    <br/>c) 用户使用非正当手段利用“即嗨”bug进行不正当获利的行为。
    <br/>d) 利用“即嗨”提供的公众平台进行广告发布，销售商品或者进行任何侵害“即嗨”利益的行为。
    <br/>e) 任何冒充“即嗨”客服，冒充“即嗨”官方团队发布虚假欺骗信息的行为。
    <br/>10) 就“即嗨”及其商业合作伙伴的服务、产品、业务咨询应选取“即嗨”指定的客户服务渠道或其他官方渠道沟通，不得在公众场合发布有关“即嗨”及相关服务的负面宣传。
    <br/>11) 如发现任何非法使用用户账号或账号出现安全漏洞的情况，应立即通知“即嗨”团队。
    <br/>12) 当用户账户涉嫌盗号、外挂等非法和违规行为时，用户应配合“即嗨”员工的工作，据实回答管理人员提出的与使用“即嗨”产品相关的问题，以维护本人和其他用户在“即嗨”的合法权益。
    <br/>13) 不得通过违反“即嗨”使用规则等非正常方式获得“即嗨”中的虚拟物品（包括但不限于虚拟货币）。

    <br/>14) 未经“即嗨”授权，利用“即嗨”提供的相关网络服务以任何方式收集任何其他用户的信息，包括但不限于用户的个人身份信息和通讯信息。

    <br/>15) 不得利用“即嗨”的服务或产品发送或传播敏感信息和违反国家法律制度的信息，包括但不限于：

    <br/>a) 危害国家及社会安全信息，其表现可能包括但不限于反对宪法所确定的基本原则；危害国家安全，泄露国家机密，颠覆国家政权，破坏国家统一；煽动民族仇恨、民族歧视，破坏民族团结；破坏国家宗教政策，宣扬邪教和封建迷信；散布谣言，扰乱社会秩序，破坏社会稳定；宣扬赌博、暴力、凶杀、恐怖或者教唆犯罪；煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；含有法律、行政法规和国家规定禁止的其他内容；

    <br/>b) 不安全信息，其表现可能包括但不限于含钓鱼网站链接的相关内容；含木马或其他病毒网站链接及相关内容；含潜在危险、窃取用户隐私等相关内容；影响用户体验或被大量用户举报的未经审核的外链、二维码及其他多媒体等内容；
    <br/>c) 垃圾营销信息，其表现可能包括但不限于从事买卖粉丝及相关业务；从事刷评论、刷转发、刷双井号话题词、刷搜索、刷投票、刷有奖活动业务；通过机器或软件等非人力手段对他人页面大量发送广告信息；机器抓取发送的无意义内容、重复内容；利用系统漏洞干扰即嗨正常秩序（如盗用其他用户账号、强制其他用户关注等）；影响用户体验或被大量用户举报的、在性质上属于推销宣传推广的营销信息；

    <br/>d) 淫秽色情信息，其表现可能包括但不限于发布淫秽、色情内容，包括但不限于招嫖、寻找一夜情、性伴侣等内容；发布以色情为目的的情色文字、情色视频、情色图画等内容；长期发布与淫秽、色情内容擦边的或具有性暗示类的内容；
    <br/>e) 欺诈信息，其表现可能包括但不限于发布虚假广告、虚假中奖信息等内容；

    <br/>f) 不正当竞争信息，其表现可能包括但不限于发布篡改、增减、删除权利标识的内容；

    <br/>g) 侵犯第三方合法权益（包括但不限于肖像权、隐私权、名誉权、商业秘密、商标权、著作权等）的信息；

    <br/>h) 其他违反法律法规的内容。

    <h5>3.2</h5>
    “即嗨”有权采取技术措施防止用户从事任何非法行为，包括但不限于进行任何诸如发布广告，销售商品的商业行为，或者进行任何非法的侵害“即嗨”利益的行为，如贩卖外挂、嗨币等。

    <h4>四、服务内容</h4>
    <h5>4.1</h5>
    “即嗨”网络服务的具体内容由“即嗨”根据实际情况提供。

    <h5>4.2</h5>
    除非本服务协议另有其他明示规定，“即嗨”所推出的新产品、新功能、新服务，均受到本服务协议之规范。

    <h5>4.3</h5>
    鉴于网络服务的特殊性，用户同意“即嗨”有权不经事先通知，随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。“即嗨”不担保网络服务不会变更、中断或终止，对网络服务的及时性、安全性、准确性也都不作担保。

    <h5>4.4</h5>
    “即嗨”需要定期或不定期对提供网络服务的平台或相关的设备进行检修或维护，如因此类情况而造成网络服务（包括收费网络服务）在合理时间内的中断，“即嗨”无需为此承担任何责任。“即嗨”保留不经事先通知为维修保养、升级或其他目的的暂停本服务任何部分的权利。

    <h5>4.5</h5>
    本服务或第三人可提供与其他国际互联网之网站或资源之链接。由于“即嗨”无法控制这些网站及资源，用户了解并同意，此类网站或资源是否可供利用，“即嗨”不予负责；存在或源于此类网站或资源之任何内容、广告、产品、或者其他材料，“即嗨”亦不予保证或负责。用户因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、商品或服务所产生的任何损害或损失，“即嗨”不承担任何责任。

    <h5>4.6</h5>
    服务的中止与终止：
    <br/>1) 用户了解并同意：“即嗨”可随时根据实际情况终止服务。之前有权单方不经通知终止向用户提供某一项或多项服务，但根据法律法规规定或用户与“即嗨”的约定需要提前通知的除外。结束用户服务后，用户使用“即嗨”产品和服务的权利立即终止。从此时起，即嗨不再对用户承担任何义务。如果服务被终止，“即嗨”可以从服务器上永久地删除用户账户数据,但法律法规另有规定的除外。服务终止后，“即嗨”没有义务向用户返还数据。

    <br/>2) 用户了解并同意：在一个“即嗨”账号充值之前，“即嗨”对其提供的是完全免费的服务。基于免费服务的成本限制，“即嗨”有权根据运营需要随时终止对该账户的服务。服务变更、中止与结束属于“即嗨”商业决策之内容。用户不得因服务的变更、中止或者结束而要求“即嗨”继续提供服务或者承担任何形式的赔偿责任等。

    <br/>3) 用户了解并同意：若一个“即嗨”账号连续一年未登陆，“即嗨”服务系统可以不再保留该账号及该账号有关的数据。

    <h4>五、自费政策</h4>
    <h5>5.1</h5>
    “即嗨”向用户提供的产品和服务本身属于商业行为，用户需要支付相应的费用。在此情况下，“即嗨”会在相关页面上做明确的提示。如用户不同意支付该等费用，则可不接受相关的服务。

    <h5>5.2</h5>
    对于“即嗨”的收费产品和服务，用户应该按照“即嗨”确定的自费政策购买；否则，“即嗨”可以立即停止向用户提供该{this.state.online ? '付费' : '游戏'}产品和服务。

    <h5>5.3</h5>
    “即嗨”将有权决定并随时修改所提供的产品和服务的自费标准和收费方式（包括免费到收费的修改），但“即嗨”会将有关产品和服务的资费标准、收费方式、购买方式或其他有关资费政策的信息放置在该产品和服务相关网页的显著位置。

    <h4>六、知识产权和其他合法权益</h4>
    <h5>6.1</h5>
    对于用户通过“即嗨”服务（包括但不限于手机客户端、网页版等）上传到“即嗨”上可公开获取区域的任何内容，用户同意“即嗨”在全世界范围内具有免费的、永久性的、不可撤销的、非独家的和完全再许可的权利和许可，以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分），和/或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。

    <h5>6.2</h5>
    “即嗨”提供的网络服务相关的著作权、商标权、专利权、商业秘密及其他信息、技术的知识产权或其它权利，均为“即嗨”或其它权利人所有。用户不得对以上产品服务进行修改、拷贝、散布、复制、发行、授权、制作衍生著作、转移或销售。如用户未遵守本条款的上述规定，“即嗨”可立即终止向用户提供产品和服务，用户必须晓会任何已经获得的上述信息、资料、软件或产品。否则，“即嗨”将依法追究用户的法律责任。

    <h4>七、青少年用户特别提示</h4>
    <h5>7.1</h5>
    未成年人应经其监护人陪同阅读本服务条款并表示同意，方可接受本服务条款。监护人应加强对未成年人的监督和保护，因其未谨慎履行监护责任而损害未成年人利益或者影响“即嗨”利益的，应由监护人承担责任。

    <h5>7.2</h5>
    青少年用户必须遵守全国青少年网络文明公约：要善于网上学习，不浏览不良信息；要诚实友好交流，不侮辱欺诈他人；要增强自护意识，不随意约会网友；要维护网络安全，不破坏网络秩序；要有益身心健康，不沉溺虚拟时空。

    <h4>八、免责与赔偿声明</h4>

    <h5>8.1</h5>
    若“即嗨”已经明示其网络服务提供方式变更并提醒用户应当注意事项，用户未按要求操作所产生的一切后果由用户自行承担。

    <h5>8.2</h5>
    用户明确同意其使用“即嗨”网络服务所存在的风险将完全由其本人承担；因其使用“即嗨”服务而产生的一切后果也由其本人承担，“即嗨”对用户不承担任何责任。

    <h5>8.3</h5>
    “即嗨”禁止用户对本应用任何产品、服务、虚拟货币进行任何形式的私下交易，因私下购买虚拟货币等物品所产生一切损失均由用户自行承担，“即嗨”及所属公司不承担任何责任。

    <h5>8.4</h5>
    “即嗨”不对用户所有的线下交易行为及其行为引发后果承担任何责任。

    <h5>8.5</h5>
    “即嗨”对用户的行为、活动、交易或利用“即嗨”进行的非法活动不承担任何责任。

    <h5>8.6</h5>
    “即嗨”有权采取技术措施防止用户从事任何非法行为，包括但不限于进行任何诸如发布广告、销售商品等的商业行为，或者进行任何非法的侵害“即嗨”利益的行为，如贩卖外挂、虚拟货币等。

    <h5>8.7</h5>
    用户将全权负责账户提交的所有交易。在下单前请仔细检查选项，一旦订单提交成功后，将无法更改或取消。公司对用户自身原因造成的遗漏或重复下单不负任何责任。

    <h5>8.8</h5>
    “即嗨”保留在任何时候关闭或冻结用户账号的权利。

    <h5>8.9</h5>
    由以下事件造成的任何损失，“即嗨”不负任何责任：

    <h5>8.9.1</h5>
    “即嗨”的网站、服务器或网络中断。

    <h5>8.9.2</h5>
    “即嗨”的数据库、服务器丢失信息或信息遭受破坏。

    <h5>8.9.3</h5>
    不法分子攻击网站、服务器或网络供应商。

    <h5>8.9.4</h5>
    进入网站时由于网络供应商原因造成的网络缓慢。

    <h5>8.10</h5>
    所有的交易将以“即嗨”数据库中数据记录为准，“即嗨”不接纳任何投诉或争议，除非用户提供交易记录的截图或影印证据，否则“即嗨”的数据记录将作为最终的证明。

    <h4>九、违约责任</h4>
    <h5>9.1</h5>
    用户了解并同意：为保障和维护“即嗨”及其他用户的利益，如因用户违反有关法律、法规或本协议项下的任何条款而给“即嗨”或任何第三方造成损失，用户同意承担由此造成的损害赔偿责任，该等责任包括但不限于给“即嗨”造成的任何直接或间接损失。

    <h5>9.2</h5>
    因用户违反本协议约定的任意内容时，包括但不限于“即嗨”通过内容的监测程序发现或经其他用户举报而发现用户有可能或已出现违约、违法、违反公序良俗、侵犯任何一方权益时，“即嗨”有权采取如下措施：包括但不限于限制用户登录、限制用户在“即嗨”中的活动、删除与账号相关的虚拟货币、删除用户的账号和要求用户赔偿因用户从事上述行为而给“即嗨”造成的损失（包括但不限于人力成本损失、运营成本损失、商誉损失、维权损失等）、单方面解除本协议、要求用户支付违约金（违约金应与用户账号内的全部款项相等），用户在此明确同意承担上述违约责任。

    <h5>9.3</h5>
    “即嗨”对用户和使用网络服务或无法使用网络服务所产生的任何直接、间接、衍生的损害或利益损失不负责任何赔偿责任。
    <div class="lasttip">以上说明最终解释权归“即嗨”所有</div>
    </div>
</template>

<script>
import { isIOS, setTitle } from "@/utils/base.js"
export default {
    name: "userAgreement",
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    mounted () {
        setTitle('用户服务协议')
        document.getElementsByTagName('title')[0].innerHTML = '用户服务协议';
    },
    data () {
        return {
            companyName: isIOS() ? '即嗨公司' : '嗨娱公司',
            isIos: isIOS()
        }
    }
}
</script>

<style lang="less" scoped>
.agreement{
    padding:0 10px;
    line-height: 20px;
    h3,h4,h5{
        color:#171717;
        font-weight: bold;
        margin: 5px;
    }
    b{
        color:#171717;
        font-weight: bold;
    }
    h3{
        font-size: 20px;
    }
    h4{
        font-size: 17px;
    }
    h5{
        font-size: 15px;
    }
    .um{
        font-weight: 700;
        color: #000;
    }
    em{
        font-weight: bold;
        color:#171717;
    }
    i{
        &.special{
            display: none;
        }
    }
    .lasttip{
        color:#bca272;
        text-align: center;
    }
}
.agreementDark{
    background-color: #191919;
    color: #e2e2e2;
    overflow: hidden;
    h2,h3,h5,b,.um,em{
        color: #d3d3d3;
    }
}
</style>
